import { Box, Typography } from "@mui/material";
import React from "react";
import styles from "../../assets/styles/loan.module.css";
import AppIcons from "../../utils/appIcons";
import Strings from "../../utils/stringUtil";
import { Link } from "react-router-dom";
import constants from "../../utils/constantsUtil";
import { isMobile } from "../../utils/responsiveUtil";

function Intro() {
  return (
    <Box className={styles.mainContainer} position={"relative"} zIndex={1}>
      <Box
        className={`${styles.mainContainer} ${styles.flexContainer} container`}
      >
        {!isMobile && (
          <img
            src={AppIcons.imgHalfYellowVector}
            className={styles.halfYellowVector}
          />
        )}

        {/* left-section */}
        <Box className={styles.leftSectionWrapper}>
          {isMobile ? (
            <Typography className={styles.businessTitle}>
              Make Your Business Dream a Reality
            </Typography>
          ) : (
            <Typography className={styles.businessTitle}>
              Make Your <br />
              <span className={styles.dottedBorderText}>Business Dream</span>
              <br /> a Reality
              <img src={AppIcons.imgStars} className={styles.starsVector} />
            </Typography>
          )}

          <Typography className={styles.businessSubTitle}>
            {Strings.businessLoanForWomen}
          </Typography>
          <Box pb={3} pr={3} className={styles.customCursor}>
            <Link
              to={constants.mmPlayStoreUrl}
              target="_blank"
              rel="noopener noreferrer"
              className={styles.customCursor}
            >
              <img
                src={AppIcons.imgDownloadApp}
                alt={Strings.mahilaMoney}
                width={"140px"}
              />
            </Link>
          </Box>
        </Box>

        {/* right-section */}
        {!isMobile && (
          <img src={AppIcons.imgLoanHero} className={styles.rightBannerImg} />
        )}
      </Box>
      {isMobile && (
        <img src={AppIcons.imgLoanHero} className={styles.rightBannerImg} />
      )}
    </Box>
  );
}

export default Intro;
